import React from "react";
import { useQuery } from "data/hooks/useQuery";
import { ContractProcess_Get } from "data/endpoints";
import { getRouteParams } from "features/shared/helpers/routeParams";
import NoContentWrapper from "features/shared/components/noContentWrapper/NoContentWrapper";
import { ContractProcessDTO } from "../dtos/ContractProcessDTO";
import ContractProcessInfoCard from "../components/ContractProcessInfoCard";
import ContractProcessSuplyCard from "../components/ContractProcessSuplyCard";

interface Props {
  contractId: string;
}

const ContractProcessDetailSection= ({ contractId }: Props) => {
  const { data, loadStatus } = useQuery<ContractProcessDTO>(
    {
      url: ContractProcess_Get,
      routeParams: getRouteParams("contractProcessId", contractId),
    },
    { result: [], count: 0 },
    [contractId]
  );

  const item = data.result?.[0];

  return (
    <NoContentWrapper data={item ? [item] : []} loadStatus={loadStatus} noContentAsAlert>
      {item && (
        <>
          <ContractProcessInfoCard contractProcess={item} />
          <ContractProcessSuplyCard contractProcess={item} />
        </>
      )}
    </NoContentWrapper>
  );
};

export default ContractProcessDetailSection;
